export default ({ COOKIEBOT_DOMAIN_ID }, callback) => {
    const script = document.createElement('script');
    script.id = 'Cookiebot';
    script.src = 'https://consent.cookiebot.com/uc.js';
    script.dataset.cbid = COOKIEBOT_DOMAIN_ID;
    // script.dataset.blockingmode = 'auto';
    script.type = 'text/javascript';

    // Listen for successful load
    script.onload = () => {
        if (window.Cookiebot) {
            // eslint-disable-next-line no-console
            console.log('Cookiebot is available', window.Cookiebot);
            callback?.();
        } else {
            // eslint-disable-next-line no-console
            console.warn('Script loaded but Cookiebot not available yet');
            callback?.();
        }
    };

    // Listen for errors
    script.onerror = () => {
        // eslint-disable-next-line no-console
        console.log('Failed to load the Cookiebot script');
        callback?.();
    };

    document.head.appendChild(script);
};
